import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import { getRequestedWidgetSize, getIsInitialWidgetSizeWasSet } from 'shared/selectors/app-settings';

import { updateAppSettings } from 'widget/redux/client/actions/app-settings';


// If iFrame was hidden during loading, window.innerWidth can be = 0
// need to wait for setting real window.innerWidth

@connect(state => ({
  requestedWidgetSize: getRequestedWidgetSize(state),
  isSizeWasSet: getIsInitialWidgetSizeWasSet(state),
}), {
  updateAppSettings,
})
export default class SetInitialWidgetSize extends React.Component {

  static propTypes = {
    requestedWidgetSize: React.PropTypes.object,
    updateAppSettings: React.PropTypes.func,
    isSizeWasSet: React.PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  componentDidMount() {
    if (this.props.isSizeWasSet) {
      return;
    }
    this.updateWidgetSizeInterval = setInterval(this.updateWidgetSize, 200);
  }

  componentWillUnmount() {
    clearInterval(this.updateWidgetSizeInterval);
  }

  @autobind
  updateWidgetSize() {
    const widgetSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    if (!widgetSize.width) {
      return;
    }

    clearInterval(this.updateWidgetSizeInterval);
    const { requestedWidgetSize, updateAppSettings } = this.props;
    if (_.isEqual(requestedWidgetSize, widgetSize)) {
      return;
    }

    updateAppSettings({
      requestedWidgetSize: widgetSize,
    });
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/set-initial-widget-size.js